import { Box, Button, Typography, Chip } from "@mui/material";

import { styled } from "@mui/material/styles";

export const TrackingOrderDetailsWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  minHeight: "80vh",
  height: "auto",
  margin: theme.spacing(10, 0, 4),
  gap: "35px",
  alignItems: "stretch", // This ensures equal heights
  // '@media (max-width: 1100px)': {
  //   gap: '20px',
  //   margin: theme.spacing(8, 0, 4),
  //   padding: theme.spacing(0, 1),
  // },
  "@media (max-width: 998px)": {
    flexDirection: "column",
    height: "auto",
    minHeight: "auto",
    alignItems: "normal",
    gap: "20px",
    margin: theme.spacing(8, 0, 4),
    padding: theme.spacing(0, 1),
  },
  "@media (max-width: 768px)": {
    margin: theme.spacing(6, 0, 3),
    gap: "20px",
    padding: theme.spacing(0, 2),
  },
}));

export const TrackingOrderDetailsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  minHeight: "100%",
  height: "100%",
  backgroundColor: theme.palette.background.paper,
  borderRadius: "20px",
  padding: theme.spacing(3),
  position: "relative",
  boxShadow: theme.shadows[4],
  border: `1px solid ${theme.palette.divider}`,
  flex: 1,
  "@media (max-width: 998px)": {
    padding: theme.spacing(3),
    borderRadius: "18px",
    gap: "22px",
  },
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(2.5),
    borderRadius: "16px",
    gap: "20px",
    flex: 2,
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
    borderRadius: "12px",
    gap: "16px",
  },
}));

export const TrackingSidebarWrapper = styled(Box)(() => ({
  width: "100%",
  maxWidth: "480px",
  minWidth: "420px",
  display: "flex",
  flexDirection: "column",
  flex: "0 0 auto",
  // '@media (max-width: 1200px)': {
  //   maxWidth: '440px',
  //   minWidth: '380px',
  // },
  // '@media (max-width: 1100px)': {
  //   maxWidth: '420px',
  //   minWidth: '380px',
  // },
  "@media (max-width: 998px)": {
    maxWidth: "100%",
    minWidth: "auto",
    width: "100%",
    margin: "0 auto",
    flex: "none",
    order: 2, // Move to bottom on mobile
  },
  "@media (max-width: 768px)": {
    maxWidth: "100%",
    width: "100%",
    flex: 2,
  },
}));

export const TrackingMapArea = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "100%",
  position: "relative",
  borderRadius: "20px",
  overflow: "hidden",
  boxShadow: theme.shadows[4],
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  flex: 1,
  minHeight: "100%",

  "@media (max-width: 998px)": {
    maxWidth: "100%",
    width: "100%",
    margin: "0 auto",
    flex: "none",
    minHeight: "auto",
    order: 1, // Move to top on mobile
    borderRadius: "18px",
  },
  [theme.breakpoints.down("md")]: {
    borderRadius: "16px",
  },
  [theme.breakpoints.down("sm")]: {
    borderRadius: "12px",
  },
}));

export const OrderDetailsFooter = styled(Box)(({ theme }) => ({
  textAlign: "center",
  margin: theme.spacing(2, 0),
  alignItems: "center",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    margin: theme.spacing(1.5, 0),
  },
}));

export const OrderDetailsFooterTitle = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
  marginLeft: theme.spacing(1),
}));

export const TrackButtonWrap = styled(Box)(({ theme }) => ({
  minHeight: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  padding: theme.spacing(6, 4),
  backgroundColor: theme.palette.background.paper,
  borderRadius: "20px",
  boxShadow: theme.shadows[4],
  border: `1px solid ${theme.palette.divider}`,
  flex: 1,
  "@media (max-width: 998px)": {
    padding: theme.spacing(4, 3),
    minHeight: "fit-content",
    height: "auto",
    borderRadius: "18px",
  },
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(3, 2.5),
    borderRadius: "16px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2.5, 2),
    borderRadius: "12px",
  },
}));

export const CustomButton = styled(Button)(({ theme }) => ({
  background: "linear-gradient(135deg, #FF8A00 0%, #FF6B35 100%)",
  color: "#ffffff",
  fontWeight: 600,
  fontSize: "16px",
  textTransform: "none",
  borderRadius: "16px",
  padding: theme.spacing(1.5, 4),
  minWidth: "220px",
  height: "56px",
  boxShadow: "0 8px 20px rgba(255, 138, 0, 0.25)",
  border: "none",
  position: "relative",
  overflow: "hidden",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",

  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: "-100%",
    width: "100%",
    height: "100%",
    background:
      "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.15), transparent)",
    transition: "left 0.5s",
  },

  "&:hover": {
    background: "linear-gradient(135deg, #FF6B35 0%, #FF8A00 100%)",
    boxShadow: "0 12px 30px rgba(255, 138, 0, 0.35)",
    transform: "translateY(-2px)",

    "&::before": {
      left: "100%",
    },
  },

  "&:active": {
    transform: "translateY(0px)",
    boxShadow: "0 6px 15px rgba(255, 138, 0, 0.25)",
  },

  "&:focus": {
    outline: "none",
    boxShadow:
      "0 8px 20px rgba(255, 138, 0, 0.25), 0 0 0 3px rgba(255, 138, 0, 0.08)",
  },

  "@media (max-width: 768px)": {
    minWidth: "200px",
    height: "52px",
    fontSize: "15px",
    padding: theme.spacing(1.25, 3),
    borderRadius: "14px",
  },
}));

export const TracingItem = styled(Typography)(({ theme }) => ({
  color: "rgba(255,138,0,1)",
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "32px",
  textDecoration: "underline",
  cursor: "pointer",
  maxWidth: "170px",
  textAlign: "center",
  margin: theme.spacing(2, "auto"),
  wordBreak: "break-word",
  overflowWrap: "break-word",
  hyphens: "auto",
}));

export const TracingDialogTitle = styled(Typography)(({ theme }) => ({
  fontSize: "24px",
  fontWeight: 400,
  lineHeight: "32px",
  color: theme.palette.text.primary,
  padding: theme.spacing(1, 0),
}));

export const TracingDialogTitleSmall = styled(Typography)(({ theme }) => ({
  fontSize: "15px",
  fontWeight: 400,
  lineHeight: "20px",
  color: theme.palette.text.secondary,
  padding: theme.spacing(1, 0),
}));

export const TracingWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  minHeight: "100%",
  maxWidth: "700px",
  textAlign: "center",
  margin: "0 auto",
  padding: theme.spacing(6, 4),
  backgroundColor: theme.palette.background.paper,
  borderRadius: "20px",
  boxShadow: theme.shadows[4],
  border: `1px solid ${theme.palette.divider}`,
  flex: 1,
  "@media (max-width: 998px)": {
    height: "auto",
    minHeight: "fit-content",
    padding: theme.spacing(4, 3),
    borderRadius: "18px",
  },
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(3, 2.5),
    borderRadius: "16px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2.5, 2),
    borderRadius: "12px",
  },
}));

export const EstimatedDeliveryTime = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
  fontSize: "18px",
}));

export const OrderStatusText = styled(Typography)(({ theme }) => ({
  fontSize: "24px",
  fontWeight: 400,
  lineHeight: "32px",
  marginTop: theme.spacing(1),
  wordBreak: "break-word",
  overflowWrap: "break-word",
  hyphens: "auto",
}));

export const OrderStatusDescription = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  color: "#929398",
  lineHeight: "20px",
  letterSpacing: "0.25px",
  marginTop: theme.spacing(1),
  wordBreak: "break-word",
  overflowWrap: "break-word",
  hyphens: "auto",
}));

export const OrderDetailsBox = styled(Box)(({ theme }) => ({
  margin: theme.spacing(0, 0, 2, 0),
}));

export const OrderDetailsFooterCancel = styled(Box)(({ theme }) => ({
  textAlign: "center",
  position: "absolute",
  bottom: "16px",
  alignItems: "center",
  width: "100%",
}));

export const TrackingEstimatedWrapper = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(0),
}));

export const TrackingOrderDistanceWrapper = styled(Box)(({}) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "baseline",
}));

export const TrackingReceivedTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  color: theme.palette.text.primary,
  fontSize: 26,
}));

export const PreLoaderContainer = styled(Box)(() => ({
  position: "relative",
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "&.overlay": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: "112",
    position: "absolute",
    top: 0,
    left: 0,
    backgroundColor: "rgba(225, 225, 225, 0.75)",
  },
}));

export const PreloaderBlock = styled(Box)(() => ({
  marginTop: 0,
  marginBottom: 0,
  textAlign: "center",
  verticalAlign: "middle",
  position: "relative",
  display: "inline-block",
  margin: "auto",
}));

// New modern styled components for beautified OrderDetails
export const ModernOrderCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: "16px",
  padding: theme.spacing(3),
  boxShadow: theme.shadows[2],
  border: `1px solid ${theme.palette.divider}`,
  marginBottom: theme.spacing(2),
}));

export const EstimatedTimeCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.warning.light + "1a", // Add transparency
  borderRadius: "16px",
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
  border: `1px solid ${theme.palette.warning.light}`,
  boxShadow: theme.shadows[1],
  "@media (max-width: 998px)": {
    padding: theme.spacing(2.5),
    borderRadius: "14px",
    marginBottom: theme.spacing(2.5),
  },
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(2.5),
    borderRadius: "12px",
    marginBottom: theme.spacing(2.5),
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2),
    borderRadius: "10px",
    marginBottom: theme.spacing(2),
  },
}));

export const OrderInfoRow = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  minHeight: "32px",
  gap: theme.spacing(2),
  "@media (max-width: 768px)": {
    minHeight: "28px",
    gap: theme.spacing(1.5),
  },
  "@media (max-width: 480px)": {
    minHeight: "24px",
    gap: theme.spacing(1),
    flexDirection: "column",
    alignItems: "flex-start",
  },
}));

export const OrderInfoLabel = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 500,
  color: theme.palette.text.secondary,
  lineHeight: "20px",
  [theme.breakpoints.down("md")]: {
    fontSize: "16px",
    lineHeight: "18px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "16px",
    lineHeight: "16px",
  },
}));

export const OrderInfoValue = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 600,
  color: theme.palette.text.primary,
  lineHeight: "20px",
  textAlign: "right",
  flex: 1,
  maxWidth: "200px",
  // Only break words for long text, but keep order numbers intact
  '&:not([data-type="order-number"])': {
    wordBreak: "break-word",
    overflowWrap: "break-word",
    hyphens: "auto",
  },
  '&[data-type="order-number"]': {
    whiteSpace: "nowrap",
    wordBreak: "keep-all",
    overflowWrap: "normal",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "16px",
    lineHeight: "18px",
    maxWidth: "180px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "16px",
    lineHeight: "16px",
    textAlign: "left",
    maxWidth: "none",
    flex: "none",
  },
}));

export const StatusChip = styled(Chip)(({ theme }) => ({
  borderRadius: "20px",
  fontWeight: 600,
  fontSize: "12px",
  height: "28px",
  textTransform: "capitalize",
  "&.MuiChip-colorPrimary": {
    backgroundColor: "#e3f2fd",
    color: "#1976d2",
  },
  "&.MuiChip-colorSuccess": {
    backgroundColor: "#e8f5e8",
    color: "#2e7d32",
  },
  "&.MuiChip-colorWarning": {
    backgroundColor: "#fff3e0",
    color: "#f57c00",
  },
  "&.MuiChip-colorError": {
    backgroundColor: "#ffebee",
    color: "#d32f2f",
  },
  "@media (max-width: 768px)": {
    fontSize: "11px",
    height: "26px",
    borderRadius: "16px",
  },
  "@media (max-width: 480px)": {
    fontSize: "10px",
  },
}));

// OrderDetails specific styled components
export const OrderDetailsSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const EstimatedTimeHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

export const EstimatedTimeIcon = styled(Box)(({ theme }) => ({
  color: theme.palette.warning.main,
  fontSize: 20,
}));

export const EstimatedTimeLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  color: theme.palette.text.secondary,
}));

export const EstimatedTimeValue = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.primary,
}));

export const StatusSectionHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const StatusTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.primary,
}));

// MapView Styled Components - Optimized and Extracted from Inline Styles

// Main Container Styles
export const MapViewMainContainer = styled(Box)(({ theme }) => ({
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(4),
  maxWidth: "700px",
  margin: "0 auto",
  width: "100%",
  padding: theme.spacing(3),
  "@media (max-width: 768px)": {
    gap: theme.spacing(3),
    maxWidth: "100%",
    padding: theme.spacing(2.5),
  },
  "@media (max-width: 480px)": {
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  },
}));

export const MapViewProcessingContainer = styled(MapViewMainContainer)(() => ({
  maxWidth: "500px",
}));

export const MapViewTrackingContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(3),
  maxWidth: "500px",
  margin: "0 auto",
  width: "100%",
  "@media (max-width: 768px)": {
    gap: theme.spacing(2.5),
  },
}));

// Animated Icon Containers
export const AnimatedIconContainer = styled(Box)(() => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: 16,
}));

export const RejectedIconBox = styled(Box)(({ theme }) => ({
  width: 120,
  height: 120,
  borderRadius: "50%",
  background: "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 12px 40px rgba(220, 38, 38, 0.25)",
  position: "relative",
  animation: "shake 0.8s ease-in-out",
  marginTop: theme.spacing(2),
  "&::before": {
    content: '""',
    position: "absolute",
    top: "-10px",
    left: "-10px",
    right: "-10px",
    bottom: "-10px",
    borderRadius: "50%",
    background: "rgba(220, 38, 38, 0.1)",
    animation: "fadeInOut 2s ease-in-out infinite",
  },
  "@keyframes shake": {
    "0%, 100%": { transform: "translateX(0)" },
    "25%": { transform: "translateX(-5px)" },
    "75%": { transform: "translateX(5px)" },
  },
  "@keyframes fadeInOut": {
    "0%, 100%": { opacity: 0.3, transform: "scale(1)" },
    "50%": { opacity: 0.8, transform: "scale(1.05)" },
  },
}));

export const ProcessingIconBox = styled(Box)(() => ({
  width: 120,
  height: 120,
  borderRadius: "50%",
  background: "linear-gradient(135deg, #FF8A00 0%, #FF6B35 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 12px 40px rgba(255, 138, 0, 0.25)",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    top: "-10px",
    left: "-10px",
    right: "-10px",
    bottom: "-10px",
    borderRadius: "50%",
    background:
      "linear-gradient(135deg, rgba(255, 138, 0, 0.1) 0%, rgba(255, 107, 53, 0.1) 100%)",
    animation: "pulse 2s ease-in-out infinite",
  },
  "&::after": {
    content: '""',
    position: "absolute",
    top: "-20px",
    left: "-20px",
    right: "-20px",
    bottom: "-20px",
    borderRadius: "50%",
    background:
      "linear-gradient(135deg, rgba(255, 138, 0, 0.05) 0%, rgba(255, 107, 53, 0.05) 100%)",
    animation: "pulse 2s ease-in-out infinite 1s",
  },
  "@keyframes pulse": {
    "0%": {
      transform: "scale(1)",
      opacity: 1,
    },
    "50%": {
      transform: "scale(1.1)",
      opacity: 0.7,
    },
    "100%": {
      transform: "scale(1)",
      opacity: 1,
    },
  },
}));

export const TrackingIconBox = styled(Box)(() => ({
  width: 80,
  height: 80,
  borderRadius: "50%",
  background: "linear-gradient(135deg, #FF8A00 0%, #FF6B35 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 8px 25px rgba(255, 138, 0, 0.3)",
}));

// Typography Variants
export const MapViewMainTitle = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.error.dark,
  marginBottom: theme.spacing(2),
  fontSize: "2.5rem",
  animation: "slideDown 0.6s ease-out",
  "@keyframes slideDown": {
    from: { opacity: 0, transform: "translateY(-20px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "2.2rem",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "1.8rem",
  },
}));

export const MapViewProcessingTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  color: "#333",
  marginBottom: theme.spacing(2),
  fontSize: "3rem",
  background: "linear-gradient(135deg, #333 0%, #555 100%)",
  backgroundClip: "text",
  textFillColor: "transparent",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  "@media (max-width: 768px)": {
    fontSize: "2.5rem",
  },
  "@media (max-width: 480px)": {
    fontSize: "2rem",
  },
}));

export const MapViewTrackingTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: "#333",
  textAlign: "center",
  marginBottom: theme.spacing(1),
}));

export const MapViewSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  lineHeight: 1.6,
  marginBottom: theme.spacing(2),
  fontSize: "1.1rem",
  fontWeight: theme.typography.fontWeightMedium,
  animation: "slideUp 0.6s ease-out 0.2s both",
  wordBreak: "break-word",
  overflowWrap: "break-word",
  wordWrap: "break-word",
  hyphens: "auto",
  whiteSpace: "normal",
  maxWidth: "100%",
  width: "100%",
  boxSizing: "border-box",
  overflow: "hidden",
  textOverflow: "clip",
  // iOS Safari specific fixes
  "-webkit-hyphens": "auto",
  "-webkit-overflow-scrolling": "touch",
  "-webkit-text-size-adjust": "none",
  "@keyframes slideUp": {
    from: { opacity: 0, transform: "translateY(20px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
    wordBreak: "break-all",
    overflowWrap: "anywhere",
  },
}));

export const MapViewDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.disabled,
  lineHeight: 1.5,
  fontSize: "1rem",
  animation: "slideUp 0.6s ease-out 0.4s both",
  wordBreak: "break-word",
  overflowWrap: "break-word",
  hyphens: "auto",
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const MapViewTrackingDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: "center",
  lineHeight: 1.5,
  maxWidth: "300px",
}));

export const MapViewCaption = styled(Typography)(({ theme }) => ({
  color: "#999",
  display: "block",
  textAlign: "center",
  marginTop: theme.spacing(1),
  fontSize: "0.75rem",
}));

export const MapViewOpenCaption = styled(Typography)(({ theme }) => ({
  color: "#999",
  textAlign: "center",
  marginTop: theme.spacing(1),
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.5),
}));

// Card Components
export const MapViewReasonCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.error.light + "20",
  borderRadius: "16px",
  padding: theme.spacing(3),
  border: `1px solid ${theme.palette.error.light}`,
  width: "100%",
  marginBottom: theme.spacing(3),
  animation: "fadeIn 0.8s ease-out 0.6s both",
  "@keyframes fadeIn": {
    from: { opacity: 0, transform: "scale(0.95)" },
    to: { opacity: 1, transform: "scale(1)" },
  },
  "@media (max-width: 768px)": {
    padding: theme.spacing(2),
    borderRadius: "12px",
    marginBottom: theme.spacing(2.5),
  },
  "@media (max-width: 480px)": {
    padding: theme.spacing(2),
    borderRadius: "10px",
    marginBottom: theme.spacing(2),
  },
}));

export const MapViewSupportCard = styled(Box)(({ theme }) => ({
  backgroundColor: "#f8f9fa",
  borderRadius: "16px",
  padding: theme.spacing(3),
  border: "1px solid #e9ecef",
  width: "100%",
  animation: "slideUp 1s ease-out 1s both",
  "@keyframes slideUp": {
    from: { opacity: 0, transform: "translateY(20px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  "@media (max-width: 768px)": {
    padding: theme.spacing(2),
    borderRadius: "12px",
  },
  "@media (max-width: 480px)": {
    padding: theme.spacing(2),
    borderRadius: "10px",
  },
}));

export const MapViewQuoteCard = styled(Box)(({ theme }) => ({
  backgroundColor: "#f8f9fa",
  borderRadius: "16px",
  padding: theme.spacing(3),
  border: "1px solid #e9ecef",
  animation: "slideUp 1s ease-out 2s both",
  "@keyframes slideUp": {
    from: { opacity: 0, transform: "translateY(20px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  "@media (max-width: 768px)": {
    padding: theme.spacing(2.5),
    borderRadius: "12px",
  },
}));

// Layout Components
export const MapViewTitleDescriptionBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const MapViewIconTitleBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const MapViewProgressBox = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "300px",
  marginBottom: theme.spacing(3),
}));

export const MapViewProcessingStepsBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  gap: theme.spacing(4),
  flexWrap: "wrap",
  marginBottom: theme.spacing(4),
  "@media (max-width: 768px)": {
    gap: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
}));

export const MapViewProcessingStep = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(1),
  "&.step-1": {
    opacity: 1,
    animation: "fadeIn 1s ease-in 0.5s both",
  },
  "&.step-2": {
    opacity: 0.7,
    animation: "fadeIn 1s ease-in 1s both",
  },
  "&.step-3": {
    opacity: 0.4,
    animation: "fadeIn 1s ease-in 1.5s both",
  },
  "@keyframes fadeIn": {
    from: { opacity: 0, transform: "translateY(10px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
}));

export const MapViewStepIcon = styled(Box)(({ variant }) => ({
  width: 48,
  height: 48,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  ...(variant === "completed" && {
    backgroundColor: "#e8f5e8",
  }),
  ...(variant === "processing" && {
    backgroundColor: "#fff3e0",
  }),
  ...(variant === "pending" && {
    backgroundColor: "#f5f5f5",
  }),
}));

export const MapViewOrderDetailsSection = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  paddingTop: theme.spacing(3),
  borderTop: "1px solid #f0f0f0",
  width: "100%",
  animation: "slideUp 1.2s ease-out 1.2s both",
  "@keyframes slideUp": {
    from: { opacity: 0, transform: "translateY(20px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
}));

export const MapViewIntegratedOrderDetails = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  paddingTop: theme.spacing(4),
  borderTop: "1px solid #f0f0f0",
  width: "100%",
}));

export const MapViewSupportHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  marginBottom: theme.spacing(2),
}));

export const MapViewSupportList = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
}));

export const MapViewSupportItem = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}));

// Specialized Typography Components
export const MapViewReasonLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.dark,
  fontWeight: 600,
  marginBottom: theme.spacing(1),
}));

export const MapViewReasonText = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  lineHeight: 1.5,
  wordBreak: "break-word",
  overflowWrap: "break-word",
  hyphens: "auto",
}));

export const MapViewSupportTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 600,
}));

export const MapViewSupportDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  lineHeight: 1.5,
  marginBottom: theme.spacing(2),
}));

export const MapViewSupportCaption = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const MapViewQuoteText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontStyle: "italic",
  textAlign: "center",
  lineHeight: 1.5,
}));

export const MapViewStepLabel = styled(Typography)(() => ({
  fontWeight: 600,
}));

export const MapViewOrderDetailsTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  marginBottom: theme.spacing(2),
  color: theme.palette.text.primary,
  textAlign: "center",
}));

export const MapViewOrderDetailsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1.5),
}));

export const MapViewOrderDetailsRow = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  minHeight: "32px",
  gap: theme.spacing(2),
  "@media (max-width: 768px)": {
    minHeight: "28px",
    gap: theme.spacing(1.5),
  },
  "@media (max-width: 480px)": {
    minHeight: "24px",
    gap: theme.spacing(1),
    flexDirection: "column",
    alignItems: "flex-start",
  },
}));

// Custom Linear Progress Component
export const MapViewLinearProgress = styled(Box)(() => ({
  height: 6,
  borderRadius: 3,
  backgroundColor: "rgba(255, 138, 0, 0.1)",
  overflow: "hidden",
  position: "relative",
  "&::after": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    background: "linear-gradient(135deg, #FF8A00 0%, #FF6B35 100%)",
    borderRadius: 3,
    animation: "indeterminate 2s linear infinite",
  },
  "@keyframes indeterminate": {
    "0%": {
      transform: "translateX(-100%)",
    },
    "100%": {
      transform: "translateX(100%)",
    },
  },
}));

// CancelledOrderView Styled Components
export const CancelledIconBox = styled(Box)(({ theme }) => ({
  width: 120,
  height: 120,
  borderRadius: "50%",
  background: "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 12px 40px rgba(220, 38, 38, 0.25)",
  position: "relative",
  animation: "cancelledShake 0.8s ease-in-out",
  marginTop: theme.spacing(2),
  "&::before": {
    content: '""',
    position: "absolute",
    top: "-10px",
    left: "-10px",
    right: "-10px",
    bottom: "-10px",
    borderRadius: "50%",
    background: "rgba(220, 38, 38, 0.1)",
    animation: "cancelledPulse 2s ease-in-out infinite",
  },
  "@keyframes cancelledShake": {
    "0%, 100%": { transform: "translateX(0)" },
    "25%": { transform: "translateX(-3px)" },
    "75%": { transform: "translateX(3px)" },
  },
  "@keyframes cancelledPulse": {
    "0%, 100%": { opacity: 0.3, transform: "scale(1)" },
    "50%": { opacity: 0.7, transform: "scale(1.05)" },
  },
}));

export const CancelledTitle = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.error.dark,
  marginBottom: theme.spacing(2),
  fontSize: "2.5rem",
  animation: "slideDown 0.6s ease-out",
  "@keyframes slideDown": {
    from: { opacity: 0, transform: "translateY(-20px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "2.2rem",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "1.8rem",
  },
}));

export const CancelledReasonCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.error.light + "20",
  borderRadius: "16px",
  padding: theme.spacing(3),
  border: `1px solid ${theme.palette.error.light}`,
  width: "100%",
  marginBottom: theme.spacing(3),
  animation: "fadeIn 0.8s ease-out 0.6s both",
  "@keyframes fadeIn": {
    from: { opacity: 0, transform: "scale(0.95)" },
    to: { opacity: 1, transform: "scale(1)" },
  },
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(2.5),
    borderRadius: "12px",
    marginBottom: theme.spacing(2.5),
  },
  "@media (max-width: 480px)": {
    padding: theme.spacing(2),
    borderRadius: "10px",
    marginBottom: theme.spacing(2),
  },
}));

export const CancelledReasonLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.dark,
  fontWeight: theme.typography.fontWeightSemiBold,
  marginBottom: theme.spacing(1),
}));

export const CancelledReasonText = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  lineHeight: 1.5,
}));

export const CancelledSupportCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  borderRadius: "16px",
  padding: theme.spacing(3),
  border: `1px solid ${theme.palette.grey[200]}`,
  width: "100%",
  animation: "slideUp 1s ease-out 1s both",
  "@keyframes slideUp": {
    from: { opacity: 0, transform: "translateY(20px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(2.5),
    borderRadius: "12px",
  },
  "@media (max-width: 480px)": {
    padding: theme.spacing(2),
    borderRadius: "10px",
  },
}));

export const CancelledSupportTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightSemiBold,
}));

export const CancelledSupportDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  lineHeight: 1.5,
  marginBottom: theme.spacing(2),
}));

export const CancelledSupportCaption = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

// ClosedOrderView Styled Components
export const ClosedIconBox = styled(Box)(({ theme }) => ({
  width: 120,
  height: 120,
  borderRadius: "50%",
  background: `linear-gradient(135deg, ${"#FF6B35"} 0%, ${"#FF6B35"} 100%)`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: `0 12px 40px ${"#FF6B35"}40`,
  position: "relative",
  animation: "closedShake 0.8s ease-in-out",
  marginTop: theme.spacing(2),
  "&::before": {
    content: '""',
    position: "absolute",
    top: "-10px",
    left: "-10px",
    right: "-10px",
    bottom: "-10px",
    borderRadius: "50%",
    background: `${"#FF6B35"}1a`,
    animation: "closedPulse 2s ease-in-out infinite",
  },
  "@keyframes closedShake": {
    "0%, 100%": { transform: "translateX(0)" },
    "25%": { transform: "translateX(-3px)" },
    "75%": { transform: "translateX(3px)" },
  },
  "@keyframes closedPulse": {
    "0%, 100%": { opacity: 0.3, transform: "scale(1)" },
    "50%": { opacity: 0.7, transform: "scale(1.05)" },
  },
}));

export const ClosedTitle = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.error.dark,
  marginBottom: theme.spacing(2),
  fontSize: "2.5rem",
  animation: "slideDown 0.6s ease-out",
  "@keyframes slideDown": {
    from: { opacity: 0, transform: "translateY(-20px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "2.2rem",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "1.8rem",
  },
}));

export const ClosedStatusCard = styled(Box)(({ theme }) => ({
  backgroundColor: "#FF6B35" + "20",
  borderRadius: "16px",
  padding: theme.spacing(3),
  border: `1px solid #FF6B35`,
  width: "100%",
  marginBottom: theme.spacing(3),
  animation: "fadeIn 0.8s ease-out 0.6s both",
  "@keyframes fadeIn": {
    from: { opacity: 0, transform: "scale(0.95)" },
    to: { opacity: 1, transform: "scale(1)" },
  },
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(2.5),
    borderRadius: "12px",
    marginBottom: theme.spacing(2.5),
  },
}));

export const ClosedStatusLabel = styled(Typography)(({ theme }) => ({
  color: "#FF6B35",
  fontWeight: theme.typography.fontWeightSemiBold,
  marginBottom: theme.spacing(1),
  fontSize: "14px",
}));

export const ClosedStatusText = styled(Typography)(({ theme }) => ({
  lineHeight: 1.5,
  wordBreak: "break-word",
  overflowWrap: "break-word",
  hyphens: "auto",
  fontSize: "14px",
  color: "#FF6B35",
}));

export const ClosedSupportCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  borderRadius: "16px",
  padding: theme.spacing(3),
  border: `1px solid ${theme.palette.grey[200]}`,
  width: "100%",
  animation: "slideUp 1s ease-out 1s both",
  "@keyframes slideUp": {
    from: { opacity: 0, transform: "translateY(20px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(2.5),
    borderRadius: "12px",
  },
  "@media (max-width: 480px)": {
    padding: theme.spacing(2),
    borderRadius: "10px",
  },
}));

export const ClosedSupportTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightSemiBold,
}));

export const ClosedSupportDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  lineHeight: 1.5,
  marginBottom: theme.spacing(2),
  wordBreak: "break-word",
  overflowWrap: "break-word",
  hyphens: "auto",
}));

export const ClosedSupportCaption = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));
